import { useNftx } from '@nftx/react';
import { Vault } from 'nftx.js';
import { useQuery } from '@tanstack/react-query';
import { QueryKey } from '../../queryKeys';

const useMerkleLeaves = ({ vault }: { vault: Vault }) => {
  const {
    provider,
    core: { fetchMerkleLeaves },
  } = useNftx();
  const enabled = !!vault;

  return useQuery(
    [QueryKey.MERKLE_LEAVES, vault],
    () => {
      return fetchMerkleLeaves({ provider, vault });
    },
    // The merkle leaves will literally never change so just cache indefinitely
    {
      staleTime: Infinity,
      refetchInterval: false,
      enabled,
    }
  );
};

export default useMerkleLeaves;
